import { configureStore } from '@reduxjs/toolkit';
import loginReducer from './slice/loginSlice';
import dashboardReducer from './slice/dashboardSlice';

const store = configureStore({
  reducer: {
    login: loginReducer,
    dashboard: dashboardReducer,
  },
});

export default store;
